import { SET_ANONYMOUS_OFFERS_LIST } from '../actions/anonymousFinPlayer/constants';

const initialState = {
  offersList: [],
};

const anonymousFinPlayerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ANONYMOUS_OFFERS_LIST:
      return {
        ...initialState,
        offersList: action.list,
      };
    default:
      return state;
  }
};

export default anonymousFinPlayerReducer;
